const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '150px',
};
const style2 = {
  backgroundColor: '#00B050',
  color: '#fff',
};

export const HeaderStandard = [
  [
    { text: 'S.No.', style: style1 },
    { text: 'Checkpoint', style: style1 },
    { text: 'Judgement Criteria', style: style1 },
    { text: 'Method', style: style1 },
    { text: 'Picture', style: style1 },
    { text: 'Observation Before', style: style1 },
    { text: 'After', style: style1 },
    { text: 'REMARKS', style: style1 },
    { text: 'Observation Before', style: style1 },
    { text: 'After', style: style1 },
    { text: 'Remark', style: style1 },
  ],
];

export const headerConstant = {
  tableCompHeadTitle: 'GAUGE MAINTENANCE CHECKSHEET ',
  addButtonLable: '',
  datePickerLabel: 'Search By Year',
  modalTile: 'UPDATE STATUS',
};

export const apiConstant = {
  getById: 'statusCheckListRouteGaugeMaintenancePlan',
  post: 'statusCheckListRouteGaugeMaintenancePlan',
  update: 'statusCheckListRouteGaugeMaintenancePlan',
  delete: 'statusCheckListRouteGaugeMaintenancePlan',
  masterCheckListAutoComplete:
    'masterCheckListRouteGaugeMaintenancePlan/masterCheckListAutoComplete',
  getMasterCheckListById: 'masterCheckListRouteGaugeMaintenancePlan',
};

export const navigationConstant = {};
